import { getEvent, getAllEvents, deleteCalendarEvent } from '../../services/api.js'

import notifications from '../notifications.js'

function _deleteCalendarEvent(dbId) {
  let promise = deleteCalendarEvent(dbId)

  promise
    .then(() => {
      notifications.pushInfo('Event successfully deleted.')
    })
    .catch(error => {
      notifications.pushError(`Deletion failed! ${error.response.data}`)
    })

  return promise
}

function _getEvent(basedOn, data) {
  let promise = getEvent(basedOn, data)

  promise
    .catch(error => {
      notifications.pushError(`Unable to load event. ${error.response.data}`, error)
    })

  return promise
}

function _getAllEvents() {
  let promise = getAllEvents()

  promise
    .catch(error => {
      notifications.pushError(`Unable to load event. ${error.response.data}`, error)
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  getEvent: _getEvent,
  getAllEvents: _getAllEvents,
  
  deleteCalendarEvent: _deleteCalendarEvent,
}
